export type AdminSettingsSectionKey = 'general' | 'categories'

export function getAdminSettingsSectionKeys(
	canManageSettings: boolean,
	canManageCategories: boolean,
): AdminSettingsSectionKey[] {
	const keys: AdminSettingsSectionKey[] = []
	if (canManageSettings) keys.push('general')
	if (canManageCategories) keys.push('categories')
	return keys
}
